const StudyTypeEnum = {
    ROUTINE: 1,
    INPATIENT: 2,
    EMERGENCY: 3,
    COMPARATIVE_EXAMINATION: 4,
}

export default StudyTypeEnum